module.exports = __webpack_public_path__ + "media/assets/img/flags/hr-HR-cfc9643cb00e44fae64bfeda3556bfd9.png";